import { render, staticRenderFns } from "./Hdxd.vue?vue&type=template&id=c88fe41e&scoped=true"
import script from "./Hdxd.vue?vue&type=script&lang=js"
export * from "./Hdxd.vue?vue&type=script&lang=js"
import style0 from "./Hdxd.vue?vue&type=style&index=0&id=c88fe41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88fe41e",
  null
  
)

export default component.exports